import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslocoService } from '@jsverse/transloco';
import { Store } from '@ngxs/store';
import {
  AuctionItem,
  AuctionItemState,
  GetAutoVisionInventoryItemDetails,
  GetAutoVisionSoldAuctionItem,
  InventoryItem,
  OrganizationState,
  UserProfileState
} from 'remarketing-angular-library';
import { takeUntil } from 'rxjs/operators';
import { AnalyticsService, fromMatchMedia, SaComponent } from 'smartauction-frontend-micro-library';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { AutoVisionSellerLocationComponent } from '../auto-vision-seller-location/auto-vision-seller-location.component';
import { AutoVisionConditionDisclosuresComponent } from '../auto-vision-condition-disclosures/auto-vision-condition-disclosures.component';
import { AutoVisionEquipmentAccessoriesComponent } from '../auto-vision-equipment-accessories/auto-vision-equipment-accessories.component';
import { AutoVisionVehicleDetailsComponent } from '../auto-vision-vehicle-details/auto-vision-vehicle-details.component';
import { AutoVisionAuctionDetailComponent } from '../auto-vision-auction-detail/auto-vision-auction-detail.component';
import { AutoVisionCarouselComponent } from '../auto-vision-carousel/auto-vision-carousel.component';
import { AutoVisionDetailsHeaderComponent } from '../auto-vision-details-header/auto-vision-details-header.component';
import { VdpLoaderComponent } from 'remarketing-ui-components-lib';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-auto-vision-shell',
    templateUrl: './auto-vision-shell.component.html',
    styleUrls: ['./auto-vision-shell.component.scss'],
    imports: [VdpLoaderComponent, AutoVisionDetailsHeaderComponent, AutoVisionCarouselComponent, AutoVisionAuctionDetailComponent, AutoVisionVehicleDetailsComponent, AutoVisionEquipmentAccessoriesComponent, AutoVisionConditionDisclosuresComponent, AutoVisionSellerLocationComponent, AccordionModule, AsyncPipe]
})
export class AutoVisionShellComponent extends SaComponent implements OnInit {
  isDesktop$ = fromMatchMedia('(min-width: 992px)');
  inventoryItem: InventoryItem;
  auctionItem: AuctionItem;

  autoVisionShellTranslations = {
    vehicleDetails: '',
    optionsAndAccessories: '',
    fullDescription: '',
    conditionAndDisclosures: '',
    sellerUpdates: '',
    sellerAndLocation: ''
  };

  constructor(
    private readonly route: ActivatedRoute,
    private readonly store: Store,
    private readonly translocoService: TranslocoService,
    private readonly analyticsService: AnalyticsService

  ) {
    super();
  }

  ngOnInit() {
    this.getTranslations();
    this.getAutoVisionVdp(this.route.snapshot.paramMap.get('inventoryItemUuid'));
    this.setAuctionItem();
  }

  getAutoVisionVdp(inventoryItemUuid): void {
    // We are consuming the GetAutoVisionInventoryItemDetails in the child components via the DetailQueries selectors
    this.store.dispatch(new GetAutoVisionInventoryItemDetails(inventoryItemUuid));
    this.store.dispatch(new GetAutoVisionSoldAuctionItem(inventoryItemUuid));
  }

  setAuctionItem() {
    this.store.select(AuctionItemState.auctionItem).pipe(takeUntil(this.destroyed$)).subscribe(response => {
      this.auctionItem = response;
      this.analyticsAtPageload();
    });
  }

  analyticsAtPageload() {
    const userProfile = this.store.selectSnapshot(UserProfileState.userProfileState).userProfile;
    const organization = this.store.selectSnapshot(OrganizationState.organizationState).organization;
    this.analyticsService.trackPageLoad({
      page: {
        pageName: `${this.analyticsService.digitalData.page.category.site}:Sell:Manage:Details:Autovision`,
        section: 'Sell:Manage:Details:Autovision',
        site: this.analyticsService.digitalData.page.category.site,
        subsection: 'Sell:Manage:Details:Autovision',
        title: ''
      },
      user: {
        dealershipName: organization.oeName,
        dealershipSAId: organization.internalId,
        dealershipUUId: organization.oeUuid,
        userId: userProfile.userId,
        userUUId: userProfile.userUuid,
      },
      vehicleList: this.auctionItem?.inventoryItemUuid,
    });
  }

  getTranslations(): void {
    const keyParams = {
      'sellModule.details.detailsShell': {}
    };

    this.translocoService
      .selectTranslateObject(keyParams)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(translate => {
        this.autoVisionShellTranslations.vehicleDetails = translate[0].vehicleDetails;
        this.autoVisionShellTranslations.optionsAndAccessories = translate[0].optionsAndAccessories;
        this.autoVisionShellTranslations.fullDescription = translate[0].fullDescription;
        this.autoVisionShellTranslations.conditionAndDisclosures = translate[0].conditionAndDisclosures;
        this.autoVisionShellTranslations.sellerUpdates = translate[0].sellerUpdates;
        this.autoVisionShellTranslations.sellerAndLocation = translate[0].sellerAndLocation;
      });
  }
}
